import { Row, Col, Container } from "react-bootstrap"; 
import Spinner from "react-bootstrap/Spinner";

const LoadingSpinner = ({text,variant}) => {
    const divStyle = {
        height: "100%",
        width: "100%"
    }
    return (
        <Container fluid>
            <Row>
                <Col xs={12} className="text-center">
                    <Spinner animation="border" variant={variant}>
                        <span className="visually-hidden">Processing</span>
                    </Spinner>
                    {text ? <p>{text}</p> : null}
                </Col>
            </Row>
        </Container>
        
    );

};

export default LoadingSpinner;
